module.exports = __webpack_public_path__ + "img/07.55c5621a.jpg";